module.exports = __webpack_public_path__ + "img/10.cloudy-night-light.95dcebc4.svg";